import { IframelyResponse, IframelyApi } from 'apis/iframelyApi';
import React, { useState, useEffect } from 'react';
import LinkPreview from 'ui/elements/LinkPreview';

// todo not for mentions

export default function IframelyLinkPreview({ link }: { link: string }) {
  const [meta, setMeta] = useState<IframelyResponse>();
  useEffect(() => {
    if (link) {
      IframelyApi()
        .get(link)
        .then(result => {
          setMeta(result);
        })
        // iframe.ly answers 4xx for links it can't preview. The update still renders, just without a card.
        .catch(() => setMeta(undefined));
    }
  }, [link]);

  if (!meta) {
    return null;
  }

  return <LinkPreview meta={meta} url={link} />;
}
